import keplerGlReducer from "kepler.gl/reducers";
import copy from "../util/object/copy";

const keplerGLInitialState = copy(require("../config/base_config.json"))
keplerGLInitialState.mapStyle["mapboxApiAccessToken"] = process.env.REACT_APP_MAPBOX_API

export const MyKeplerGlReducer = keplerGlReducer.initialState(keplerGLInitialState)